export const QueryGroupRepository = Symbol.for('QueryGroupRepository');
